import axiosInstance from '../utils/axiosInstance';

export const fetchLeaveTypes = async (activeOnly = true) => {
  const params = activeOnly ? '?activeOnly=true' : '';
  const { data } = await axiosInstance.get(`/leave-types${params}`);
  return data;
};

export const createLeaveType = async (payload) => {
  const { data } = await axiosInstance.post('/leave-types', payload);
  return data;
};

export const updateLeaveType = async (id, payload) => {
  const { data } = await axiosInstance.put(`/leave-types/${id}`, payload);
  return data;
};

export const deleteLeaveType = async (id) => {
  const { data } = await axiosInstance.delete(`/leave-types/${id}`);
  return data;
};
